import React, { ReactNode } from 'react';
import { Button, Popconfirm } from '@duxton-web/ui';

import { ExperimentAction, isCompatibleExperiment } from '../../constants';
import { Experiment } from '../../domain';
import {
  isEligibleForPostEndEditing,
  // TEMP: Remove once temporary timeslice controlled metrics editing is no longer needed.
  isTimesliceEligibleForControlledMetricsEditing,
} from '../../utils';
import { AccessControlWrapper } from '@/common/components';
import { getDomainFamily } from '@/common/domains';
import { REQUESTED, RUNNING, SCHEDULED, STARTED } from '@/constants';
import { AdaptiveExperiment } from '@/lib/PlannerDTOs';
import { AccessTargetInput, UserAction } from '@/utils/accessControl';
import { useAppNavigate } from '@/utils/navigation';

const Edit = ({
  variableTechFamilies,
  experiment,
  adaptiveExperiment,
  ghost,
  icon,
  text,
  accessTargets,
}: {
  variableTechFamilies: string[];
  experiment: Experiment;
  adaptiveExperiment: AdaptiveExperiment;
  ghost?: boolean;
  icon?: ReactNode;
  text?: string;
  accessTargets?: AccessTargetInput[];
}) => {
  const { navigateTo } = useAppNavigate();

  const mainExperiment = experiment || adaptiveExperiment;

  const editableStates = [REQUESTED, SCHEDULED, RUNNING, STARTED];

  if (
    !editableStates.includes(mainExperiment?.state) &&
    !isEligibleForPostEndEditing(experiment) &&
    // TEMP: Remove once temporary timeslice controlled metrics editing is no longer needed.
    !isTimesliceEligibleForControlledMetricsEditing(experiment)
  ) {
    return null;
  }

  return (
    <AccessControlWrapper
      action={UserAction.EDIT_CURRENT_EXPERIMENT}
      techFamilies={variableTechFamilies}
      accessTargets={accessTargets}
      resourceState={mainExperiment?.state}
    >
      {(hasAccess) => {
        if (!hasAccess) {
          return (
            <Button disabled type="secondary" size="small">
              Edit Experiment
            </Button>
          );
        }

        return isCompatibleExperiment(mainExperiment) ? (
          <Button
            type="secondary"
            size="small"
            onClick={() => {
              navigateTo(
                `/${getDomainFamily()}/experiments/${mainExperiment?.name}/${ExperimentAction.EDIT}`,
              );
            }}
            ghost={ghost}
            icon={icon}
          >
            {text || 'Edit Experiment'}
          </Button>
        ) : (
          <Popconfirm
            placement="bottomRight"
            title={
              'This experiment is not fully compatible with the new creation flow. Do you want to edit this experiment?'
            }
            onConfirm={() => {
              navigateTo(
                `/${getDomainFamily()}/experiments/${mainExperiment?.name}/${ExperimentAction.EDIT}`,
              );
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="secondary" size="small">
              Edit Experiment
            </Button>
          </Popconfirm>
        );
      }}
    </AccessControlWrapper>
  );
};

export default Edit;
